var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget-card',{attrs:{"colClasses":"xs12","heading":_vm.widget.text.caption[_vm.$i18n.locale]}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.widget.data.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }